import { cn } from "@/lib/utils/cn";
import type { HTMLAttributes, ReactNode } from "react";

interface EyebrowProps extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode;
}

export function Eyebrow({ className, children, ...rest }: EyebrowProps) {
  return (
    <p
      {...rest}
      className={cn(
        "font-body text-xs uppercase tracking-[0.3em] text-gold",
        className
      )}
    >
      {children}
    </p>
  );
}
